
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hYhFV", function(module, exports) {
$parcel$export(module.exports, "RootEntrypointWrapper", () => $7d06b64bd0755483$export$40adc4cb138cacb1);

var $eJOHy = parcelRequire("eJOHy");

var $ZCFdL = parcelRequire("ZCFdL");
const $7d06b64bd0755483$export$40adc4cb138cacb1 = ({ props: props, queries: { rootUiModificationsQuery: rootUiModificationsQuery } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ZCFdL.UiModificationsRoot), {
        ...props,
        queryReference: rootUiModificationsQuery
    });
};

});
parcelRegister("ZCFdL", function(module, exports) {
$parcel$export(module.exports, "UiModificationsRoot", () => $42f8698d3f0eb48d$export$da1a4f52b34addd2);

var $gt9Am = parcelRequire("gt9Am");

var $lzD9R = parcelRequire("lzD9R");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $j4oe4 = parcelRequire("j4oe4");

var $8tUN1 = parcelRequire("8tUN1");

var $fcZJN = parcelRequire("fcZJN");
const $42f8698d3f0eb48d$export$da1a4f52b34addd2 = (props)=>{
    const { queryReference: queryReference } = props;
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8tUN1.default), {
        name: "ui-modifications-root-query",
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($42f8698d3f0eb48d$var$RootQuery, {
            ...props,
            queryReference: queryReference
        })
    });
};
const $42f8698d3f0eb48d$var$RootQuery = (props)=>{
    (0, $gRw8I.di)((0, $fcZJN.UiModificationsRootFragment));
    const { queryReference: queryReference, ...restProps } = props;
    const data = (0, $j4oe4.usePreloadedQuery)((0, $lzD9R.default), queryReference);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fcZJN.UiModificationsRootFragment), {
        ...restProps,
        fragmentRef: data
    });
};

});
parcelRegister("fcZJN", function(module, exports) {
$parcel$export(module.exports, "UiModificationsRootFragment", () => $a2d8518be9c1c84b$export$c460318ed1ecaf23);

var $gt9Am = parcelRequire("gt9Am");

var $1j5P2 = parcelRequire("1j5P2");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $j4oe4 = parcelRequire("j4oe4");

var $l7RIc = parcelRequire("l7RIc");

var $3faLh = parcelRequire("3faLh");

var $iKdPZ = parcelRequire("iKdPZ");

var $3GcKx = parcelRequire("3GcKx");

var $8bF5A = parcelRequire("8bF5A");

var $5dcci = parcelRequire("5dcci");

var $3CIBx = parcelRequire("3CIBx");

var $i3itQ = parcelRequire("i3itQ");

var $kpf82 = parcelRequire("kpf82");

var $h6Jc5 = parcelRequire("h6Jc5");
const $a2d8518be9c1c84b$export$c460318ed1ecaf23 = (props)=>{
    const executionContext = (0, $h6Jc5.useEnrichedExecutionContext)({
        executionContext: props.executionContext
    });
    const { executionContextKey: executionContextKey, triggerPointKey: triggerPointKey } = props;
    const viewType = (0, $3GcKx.useViewType)();
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $3faLh.useAdjustmentsContextActions)();
    const shouldLoad = executionContext && executionContextKey && (0, $5dcci.isTriggerPointSupported)(viewType, triggerPointKey) && (0, $5dcci.isExecutionContextSupported)(executionContext);
    (0, $eJOHy.useEffect)(()=>{
        // `executionContextKey` has to be the dependency of the useEffect
        // to set the shouldUiModificationsLoad state according to context changes
        // that is represented by the `executionContextKey`
        if (shouldLoad) setShouldUiModificationsLoad(shouldLoad ? 'yes' : 'no');
    }, [
        setShouldUiModificationsLoad,
        shouldLoad,
        executionContextKey
    ]);
    if (!shouldLoad) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($a2d8518be9c1c84b$var$RootFragmentWithCleanup, {
        ...props,
        executionContext: executionContext,
        executionContextKey: executionContextKey
    });
};
/**
 * It is separated from
 * - `UiModificationsRootFragment` to run cleanup only when we know that we want to render UIM
 * - `RootFragment` to run cleanup imidiately without awaiting for the new Relay data when context changed
 */ const $a2d8518be9c1c84b$var$RootFragmentWithCleanup = (props)=>{
    (0, $gRw8I.di)((0, $l7RIc.default));
    const { cloudId: cloudId, activationId: activationId, executionContextKey: executionContextKey, triggerPointKey: triggerPointKey, executionContext: executionContext, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = props;
    (0, $kpf82.useContextCleanup)({
        executionContextKey: executionContextKey,
        numberOfSupportedFields: numberOfSupportedFields,
        resetFormFieldsCounter: resetFormFieldsCounter
    });
    const tenantContext = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            activationId: activationId
        }), [
        cloudId,
        activationId
    ]);
    const analyticsContextData = (0, $eJOHy.useMemo)(()=>({
            attributes: {
                triggerPointKey: triggerPointKey
            }
        }), [
        triggerPointKey
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l7RIc.default), {
        data: analyticsContextData,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iKdPZ.ExecutionContextProvider), {
            value: executionContext,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8bF5A.TenantContextProvider), {
                value: tenantContext,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($a2d8518be9c1c84b$var$RootFragment, {
                    ...props
                })
            })
        })
    });
};
const $a2d8518be9c1c84b$var$RootFragment = ({ fragmentRef: fragmentRef, ForgeAppRenderer: ForgeAppRenderer, executionContextKey: executionContextKey })=>{
    (0, $gRw8I.di)((0, $3CIBx.AppsRenderer));
    const response = (0, $j4oe4.useFragment)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $1j5P2.default), /* eslint-enable @atlassian/relay/unused-fields */ fragmentRef);
    const appsToRender = (0, $i3itQ.useAppsToRender)({
        data: response,
        executionContextKey: executionContextKey
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3CIBx.AppsRenderer), {
        apps: appsToRender,
        ForgeAppRenderer: ForgeAppRenderer
    });
};

});
parcelRegister("1j5P2", function(module, exports) {
$parcel$export(module.exports, "default", () => $ade2697c6936d043$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0d4369f19f2aa2d86b1af0d493510b82>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ade2697c6936d043$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "forgeExtensionRenderingContext"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "uiModificationsContext"
            }
        ],
        "kind": "Fragment",
        "name": "fragment_AtlassianUiModificationsCore_RootFragment",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "uiModificationsContext"
                                }
                            ],
                            "concreteType": "JiraAppUiModifications",
                            "kind": "LinkedField",
                            "name": "uiModifications",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appEnvId"
                                },
                                {
                                    "concreteType": "JiraUiModification",
                                    "kind": "LinkedField",
                                    "name": "uiModifications",
                                    "plural": true,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "data"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "NONE",
                        "path": "jira.uiModifications"
                    },
                    {
                        "concreteType": "JiraForgeQuery",
                        "kind": "LinkedField",
                        "name": "forge",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "uiModificationsExtensions",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "context",
                                            "variableName": "forgeExtensionRenderingContext"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "jira:uiModifications"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraForgeExtension",
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "appVersion"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "installationId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentKey"
                                        },
                                        {
                                            "concreteType": "JiraForgeExtensionLicense",
                                            "kind": "LinkedField",
                                            "name": "license",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "active"
                                                },
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "supportEntitlementNumber"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "trialEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "subscriptionEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEvaluation"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "billingPeriod"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementSlug"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "capabilitySet"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "properties"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        },
                                        v1 /*: any*/ ,
                                        {
                                            "concreteType": "JiraForgeAppEgressDeclaration",
                                            "kind": "LinkedField",
                                            "name": "egress",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "addresses"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inScopeEUD"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraForgeInstallationConfigExtension",
                                            "kind": "LinkedField",
                                            "name": "installationConfig",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "consentUrl"
                                        },
                                        {
                                            "concreteType": "JiraUserAppAccess",
                                            "kind": "LinkedField",
                                            "name": "userAccess",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasAccess"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "enabled"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                "action": "NONE",
                                "path": "jira.forge.uiModificationsExtensions"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$ade2697c6936d043$var$node.hash = "ff48dbe4ed2ab636d857ff6d8fc8b30f";
var $ade2697c6936d043$export$2e2bcd8739ae039 = $ade2697c6936d043$var$node;

});

parcelRegister("iKdPZ", function(module, exports) {
$parcel$export(module.exports, "useExecutionContext", () => $6456568d50ead1f1$export$b0467ce6d1ed861f);
$parcel$export(module.exports, "ExecutionContextProvider", () => $6456568d50ead1f1$export$14f2a780bc6de643);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $6456568d50ead1f1$export$7f8a924805594460 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $6456568d50ead1f1$export$b0467ce6d1ed861f = ()=>{
    const executionContext = (0, $eJOHy.useContext)($6456568d50ead1f1$export$7f8a924805594460);
    if (executionContext === null) throw new Error('executionContext value is null');
    return executionContext;
};
const $6456568d50ead1f1$export$14f2a780bc6de643 = ({ children: children, value: value })=>{
    if (!value) throw new Error('ExecutionContextProvider requires a value');
    return /*#__PURE__*/ (0, $gt9Am.jsx)($6456568d50ead1f1$export$7f8a924805594460.Provider, {
        value: value,
        children: children
    });
};

});

parcelRegister("8bF5A", function(module, exports) {
$parcel$export(module.exports, "useTenantContext", () => $f058f0b1ceb6f108$export$28e7c557f4d454d9);
$parcel$export(module.exports, "TenantContextProvider", () => $f058f0b1ceb6f108$export$e32355e80a92030c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $f058f0b1ceb6f108$var$TenantContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $f058f0b1ceb6f108$export$28e7c557f4d454d9 = ()=>{
    const tenantContext = (0, $eJOHy.useContext)($f058f0b1ceb6f108$var$TenantContext);
    if (tenantContext === null) throw new Error('tenantContext value is null');
    return tenantContext;
};
const $f058f0b1ceb6f108$export$e32355e80a92030c = ({ children: children, value: value })=>{
    if (!value) throw new Error('TenantContextProvider requires a value');
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f058f0b1ceb6f108$var$TenantContext.Provider, {
        value: value,
        children: children
    });
};

});

parcelRegister("3CIBx", function(module, exports) {
$parcel$export(module.exports, "AppsRenderer", () => $801d9adcd39cc8e3$export$d013b75640a90b27);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $l7RIc = parcelRequire("l7RIc");

var $5IjLF = parcelRequire("5IjLF");

var $5yhwD = parcelRequire("5yhwD");

var $jrVrb = parcelRequire("jrVrb");
const $801d9adcd39cc8e3$export$d013b75640a90b27 = ({ ForgeAppRenderer: ForgeAppRenderer, apps: apps })=>{
    const [triggerFieldInitializationKey] = (0, $5yhwD.useTriggerFieldInitialization)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: apps.map(({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig })=>{
            const { appId: appId, environmentId: envId } = (0, $5IjLF.parseExtensionId)(forgeExtension.id);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l7RIc.default), {
                data: {
                    attributes: {
                        appId: appId,
                        envId: envId
                    }
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jrVrb.SingleAppRenderer), {
                    forgeExtension: forgeExtension,
                    uiModificationsConfig: uiModificationsConfig,
                    ForgeAppRenderer: ForgeAppRenderer
                })
            }, `${forgeExtension.id}-${triggerFieldInitializationKey}`);
        })
    });
};

});
parcelRegister("5IjLF", function(module, exports) {
$parcel$export(module.exports, "parseExtensionId", () => $b0b07de79343b050$export$bae42cbaf7fa3e1b);

var $63yBZ = parcelRequire("63yBZ");
const $b0b07de79343b050$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $63yBZ.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};

});
parcelRegister("63yBZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

var $ik6eF = parcelRequire("ik6eF");

$dnskZ.__exportStar((parcelRequire("jWqQq")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $468ddf0950beb311$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $468ddf0950beb311$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $468ddf0950beb311$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $468ddf0950beb311$var$InvalidAriError;
function $468ddf0950beb311$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $468ddf0950beb311$var$basicCharConstraint = $ik6eF.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $468ddf0950beb311$var$resourceTypeCharConstraints = $ik6eF.pattern(/^[a-z][a-z.-]*$/i);
const $468ddf0950beb311$var$resourceOwnerConstraints = [
    $ik6eF.lengthBetween(3, 255),
    $468ddf0950beb311$var$basicCharConstraint
];
const $468ddf0950beb311$var$resourceTypeConstraints = [
    $ik6eF.lengthBetween(3, 255),
    $468ddf0950beb311$var$resourceTypeCharConstraints
];
const $468ddf0950beb311$var$cloudIdConstraints = [
    $ik6eF.lengthBetween(3, 255)
];
const $468ddf0950beb311$var$siteResourceType = 'site';
const $468ddf0950beb311$var$resourceIdChars = /[\w-._~:@#]/.source;
const $468ddf0950beb311$var$resourceIdConstraints = [
    $ik6eF.pattern(new RegExp(`^${$468ddf0950beb311$var$resourceIdChars}+(/${$468ddf0950beb311$var$resourceIdChars}*)*(;v=${$468ddf0950beb311$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $468ddf0950beb311$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $468ddf0950beb311$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $468ddf0950beb311$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $468ddf0950beb311$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $468ddf0950beb311$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        return new $468ddf0950beb311$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $468ddf0950beb311$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $468ddf0950beb311$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $468ddf0950beb311$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $468ddf0950beb311$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $468ddf0950beb311$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $468ddf0950beb311$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $468ddf0950beb311$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $468ddf0950beb311$var$siteResourceType && !!other.resourceType || $468ddf0950beb311$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $468ddf0950beb311$var$siteResourceType && !!other.resourceType || $468ddf0950beb311$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $468ddf0950beb311$var$siteResourceType && !cloudId) return new $ik6eF.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $ik6eF.validateField(this, 'resourceOwner', $468ddf0950beb311$var$resourceOwnerConstraints),
            $ik6eF.validateField(this, 'resourceType', $468ddf0950beb311$var$resourceTypeConstraints),
            $ik6eF.validateField(this, 'resourceId', $468ddf0950beb311$var$resourceIdConstraints),
            $ik6eF.validateField(this, 'cloudId', $468ddf0950beb311$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $468ddf0950beb311$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $468ddf0950beb311$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $468ddf0950beb311$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $468ddf0950beb311$var$parse(ariString) {
    return $468ddf0950beb311$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $468ddf0950beb311$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $468ddf0950beb311$var$parseEncoded(encodedAriString) {
    return $468ddf0950beb311$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $468ddf0950beb311$var$parseEncoded;

});
parcelRegister("ik6eF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eDoz3 = parcelRequire("eDoz3");
class $d56eee7d06fcc64a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $d56eee7d06fcc64a$var$LengthConstraint;
class $d56eee7d06fcc64a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $d56eee7d06fcc64a$var$RegexConstraint;
class $d56eee7d06fcc64a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $d56eee7d06fcc64a$var$GeneralValidationError;
class $d56eee7d06fcc64a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $d56eee7d06fcc64a$var$ConstraintViolation;
function $d56eee7d06fcc64a$var$lengthBetween(min, max) {
    return new $d56eee7d06fcc64a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $d56eee7d06fcc64a$var$lengthBetween;
function $d56eee7d06fcc64a$var$pattern(regex) {
    return new $d56eee7d06fcc64a$var$RegexConstraint(regex);
}
module.exports.pattern = $d56eee7d06fcc64a$var$pattern;
function $d56eee7d06fcc64a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($eDoz3.isDefined);
    return violatedConstraints.length > 0 ? new $d56eee7d06fcc64a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $d56eee7d06fcc64a$var$validateField;

});
parcelRegister("eDoz3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $aa77c3314e9d9437$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $aa77c3314e9d9437$var$isPresent;
function $aa77c3314e9d9437$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $aa77c3314e9d9437$var$isDefined;
function $aa77c3314e9d9437$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $aa77c3314e9d9437$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $aa77c3314e9d9437$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $aa77c3314e9d9437$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $aa77c3314e9d9437$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $aa77c3314e9d9437$var$hasValueAtKey;

});


parcelRegister("jWqQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4ZFVe = parcelRequire("4ZFVe");
var $e84841da69f5e74e$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($e84841da69f5e74e$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $e84841da69f5e74e$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $e84841da69f5e74e$var$AppFamilyAriError;
class $e84841da69f5e74e$var$NotAppFamilyAriError extends $e84841da69f5e74e$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $e84841da69f5e74e$var$NotAppFamilyAriError;
class $e84841da69f5e74e$var$NotExpectedAppFamilyAriTypeError extends $e84841da69f5e74e$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $e84841da69f5e74e$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $e84841da69f5e74e$var$parseAppAri(ari) {
    return $4ZFVe.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $e84841da69f5e74e$var$parseAppAri;
function $e84841da69f5e74e$var$createAppAri(json) {
    return new $4ZFVe.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $e84841da69f5e74e$var$createAppAri;

});
parcelRegister("4ZFVe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jWqQq = parcelRequire("jWqQq");

var $63yBZ = parcelRequire("63yBZ");

var $ik6eF = parcelRequire("ik6eF");
const $3a2d60ca363a4626$var$versionPrefix = ';v=';
const $3a2d60ca363a4626$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $3a2d60ca363a4626$var$uuidConstraints = [
    $ik6eF.pattern(new RegExp(`^${$3a2d60ca363a4626$var$uuidRegExpString}$`, 'i'))
];
const $3a2d60ca363a4626$var$extensionGroupIdConstraints = [
    $ik6eF.pattern(new RegExp(`^(${$3a2d60ca363a4626$var$uuidRegExpString}|static)$`, 'i'))
];
class $3a2d60ca363a4626$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $jWqQq.AppFamilyAri.resourceOwner) throw new $jWqQq.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$jWqQq.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $jWqQq.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $jWqQq.NotAppFamilyAriError(ari, `resourceType must be one of ${$jWqQq.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $jWqQq.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($3a2d60ca363a4626$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($3a2d60ca363a4626$var$versionPrefix) > versionIndex) throw new $jWqQq.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($3a2d60ca363a4626$var$versionPrefix);
        const segments = mainResourceId.split('/').map($3a2d60ca363a4626$var$stripToUndefined);
        if (segments.length > 4) throw new $jWqQq.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $jWqQq.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $jWqQq.AppFamilyAri.extensionGroupResourceType || resourceType === $jWqQq.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $jWqQq.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$jWqQq.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$jWqQq.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$jWqQq.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$jWqQq.AppFamilyAri.environmentResourceType}`);
        return new $3a2d60ca363a4626$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $jWqQq.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $ik6eF.validateField(this, 'environmentId', $3a2d60ca363a4626$var$uuidConstraints),
            $ik6eF.validateField(this, 'appId', $3a2d60ca363a4626$var$uuidConstraints),
            $ik6eF.validateField(this, 'extensionGroupId', $3a2d60ca363a4626$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $63yBZ.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $jWqQq.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$3a2d60ca363a4626$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $3a2d60ca363a4626$var$AppFamilyAriImpl;
function $3a2d60ca363a4626$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});




parcelRegister("jrVrb", function(module, exports) {
$parcel$export(module.exports, "SingleAppRenderer", () => $638514db3ef0cc73$export$53c5b0cb268c246d);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8tUN1 = parcelRequire("8tUN1");

var $5IjLF = parcelRequire("5IjLF");

var $deXzx = parcelRequire("deXzx");


var $iKdPZ = parcelRequire("iKdPZ");

var $3GcKx = parcelRequire("3GcKx");

var $dVO4Z = parcelRequire("dVO4Z");

var $5dcci = parcelRequire("5dcci");

var $3u8FU = parcelRequire("3u8FU");

var $ltaAX = parcelRequire("ltaAX");

var $5svRh = parcelRequire("5svRh");

var $c04JC = parcelRequire("c04JC");

var $58a6U = parcelRequire("58a6U");
const $638514db3ef0cc73$export$53c5b0cb268c246d = ({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig, ForgeAppRenderer: ForgeAppRenderer })=>{
    const { scopes: moduleScopes, id: moduleId } = forgeExtension;
    const { setError: setError } = (0, $dVO4Z.useIssueAdjustmentsActions)();
    const viewType = (0, $3GcKx.useViewType)();
    const executionContext = (0, $iKdPZ.useExecutionContext)();
    const extensionData = (0, $eJOHy.useMemo)(()=>(0, $58a6U.buildExtensionData)(executionContext), [
        executionContext
    ]);
    const { appId: appId } = (0, $5IjLF.parseExtensionId)(moduleId);
    // This hook can be removed and replaced with `onTimeout` from LazyIframe once
    // https://ecosystem.atlassian.net/browse/BUILD-1617 is done. For now it approximates an
    // iframe timeout if the iframe doesn't use the custom bridge method needed by @forge/jira-bridge
    const { setLoadingComplete: setLoadingComplete } = (0, $ltaAX.useIframeTimeout)({
        forgeExtension: forgeExtension
    });
    const { customBridgeMethods: customBridgeMethods } = (0, $3u8FU.useCustomBridgeMethods)({
        onBridgeCommunicationReceived: setLoadingComplete,
        uiModifications: uiModificationsConfig,
        moduleScopes: moduleScopes,
        appId: appId
    });
    const requiredScopesFound = (0, $5svRh.useScopeChecks)(moduleScopes);
    const currentUIModificationsConsentStatus = (0, $deXzx.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    (0, $eJOHy.useEffect)(()=>{
        if (!requiredScopesFound) {
            setError({
                errorCode: 'SCOPES_MISSING_ERROR_CODE'
            });
            setLoadingComplete();
            (0, $5dcci.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        requiredScopesFound,
        setError,
        setLoadingComplete,
        viewType
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (currentUIModificationsConsentStatus === (0, $d289da392ecd1c15$export$d67d63332ce3ce38)) {
            setLoadingComplete();
            (0, $5dcci.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        currentUIModificationsConsentStatus,
        setLoadingComplete,
        viewType
    ]);
    const consentProps = (0, $c04JC.useThreeLOPromptProps)({
        forgeExtension: forgeExtension
    });
    if (!requiredScopesFound) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8tUN1.default), {
        name: "single-frame-iframe",
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(ForgeAppRenderer, {
            extension: forgeExtension,
            extensionData: extensionData,
            customBridgeMethods: customBridgeMethods,
            onIframeLoad: (0, $5dcci.getAnalytics)(viewType).markIframeLoad,
            isIframeResizable: false,
            isIframeHidden: true,
            ...consentProps
        })
    }, moduleId);
};

});
const $d289da392ecd1c15$export$39d15f3568f5a72c = 'unknown';
const $d289da392ecd1c15$export$d67d63332ce3ce38 = 'required';
const $d289da392ecd1c15$export$45ca911896c5084f = 'consented';

parcelRegister("3u8FU", function(module, exports) {
$parcel$export(module.exports, "useCustomBridgeMethods", () => $cc1e243a7232a157$export$88571489e690a256);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");


var $cU2cK = parcelRequire("cU2cK");

var $da6RM = parcelRequire("da6RM");

var $5V6jy = parcelRequire("5V6jy");

var $i0YmB = parcelRequire("i0YmB");

var $gHcMh = parcelRequire("gHcMh");

var $j9qqW = parcelRequire("j9qqW");
const $cc1e243a7232a157$export$88571489e690a256 = ({ onBridgeCommunicationReceived: onBridgeCommunicationReceived, uiModifications: uiModifications, moduleScopes: moduleScopes = [], appId: appId })=>{
    const { onInitPromise: onInitPromise } = (0, $i0YmB.useOnInit)({
        moduleScopes: moduleScopes
    });
    const subscribeToChanges = (0, $da6RM.useOnChangeSubscription)({
        uiModifications: uiModifications,
        moduleScopes: moduleScopes
    });
    const submit = (0, $j9qqW.useSubmit)({
        moduleScopes: moduleScopes,
        appId: appId
    });
    const registerFields = (0, $gHcMh.useRegisterFields)({
        appId: appId
    });
    const onBridgeError = (0, $cU2cK.useOnBridgeError)({
        appId: appId
    });
    const subscribeToErrors = (0, $5V6jy.useOnErrorSubscription)({
        appId: appId
    });
    const getInternalAPI = (0, $eJOHy.useCallback)(()=>{
        onBridgeCommunicationReceived?.();
        return {
            data: {
                onInitChangeId: (0, $66e1e5b286ca8af9$export$415cc1afa6445f90),
                uiModifications: uiModifications,
                featureFlags: {
                    // keep as true, we will also need to do the forge-bridge clean-up
                    // and wait for some period of time so the users will migrate to the version without this FG.
                    'forge-ui-modifications-screentabs_qoa33': true
                }
            },
            actions: {
                getOnInitData: ()=>onInitPromise,
                subscribeToChanges: subscribeToChanges,
                submit: submit,
                registerFields: registerFields,
                onBridgeError: onBridgeError,
                subscribeToErrors: subscribeToErrors
            }
        };
    }, [
        onBridgeCommunicationReceived,
        uiModifications,
        subscribeToChanges,
        submit,
        registerFields,
        onInitPromise,
        onBridgeError,
        subscribeToErrors
    ]);
    const customBridgeMethods = (0, $eJOHy.useMemo)(()=>({
            getUiModificationsInternalAPI: getInternalAPI
        }), // TODO: Make sure that the `getInternalAPI` is not being regenerated on the consecutive renders
    // because the bridge consumes only the first version of it, if so clear the array deps to be [].
    [
        getInternalAPI
    ]);
    return {
        customBridgeMethods: customBridgeMethods
    };
};

});
const $66e1e5b286ca8af9$export$415cc1afa6445f90 = 'onInitChangeId';
const $66e1e5b286ca8af9$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("cU2cK", function(module, exports) {
$parcel$export(module.exports, "useOnBridgeError", () => $db7f7487877de949$export$7b14c142027ef2e2);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $546O5 = parcelRequire("546O5");

var $kcZQW = parcelRequire("kcZQW");

var $3GcKx = parcelRequire("3GcKx");

var $dVO4Z = parcelRequire("dVO4Z");

var $5dcci = parcelRequire("5dcci");

var $37sL0 = parcelRequire("37sL0");
const $db7f7487877de949$var$isValidPayload = (payload)=>payload !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($546O5)))(payload) && (0, $37sL0.BRIDGE_ERROR_TYPES).includes(payload.error) && (!payload.changeId || typeof payload.changeId === 'string');
const $db7f7487877de949$export$7b14c142027ef2e2 = ({ appId: appId })=>{
    const { setError: setError, unregisterFields: unregisterFields } = (0, $dVO4Z.useIssueAdjustmentsActions)();
    const viewType = (0, $3GcKx.useViewType)();
    return (0, $eJOHy.useCallback)((payload)=>{
        if (!$db7f7487877de949$var$isValidPayload(payload)) return;
        const { changeId: changeId, error: error, cause: cause } = payload;
        if (changeId) unregisterFields({
            changeId: changeId,
            appId: appId
        });
        setError({
            errorCode: 'ON_BRIDGE_ERROR_ERROR_CODE'
        });
        (0, $5dcci.getAnalytics)(viewType).stopTTI({
            completionStatus: 'error',
            viewType: viewType
        });
        const UIMLoggableError = new Error(`An ${error} occurred in the UI Modifications code in the Jira Bridge`, {
            cause: cause
        });
        (0, $kcZQW.fireErrorAnalytics)({
            error: UIMLoggableError,
            id: 'UIModificationsJiraBridge',
            viewType: viewType,
            attributes: {
                type: error,
                cause: cause
            }
        });
    }, [
        setError,
        unregisterFields,
        viewType,
        appId
    ]);
};

});
parcelRegister("37sL0", function(module, exports) {
$parcel$export(module.exports, "BRIDGE_ERROR_TYPES", () => $269a045422eaddf5$export$7845535459d8a620);
const $269a045422eaddf5$export$6634aa68b37142fc = 'onInitError';
const $269a045422eaddf5$export$7ab66e58aded6116 = 'subscribeToChangesError';
const $269a045422eaddf5$export$3018e0c759270938 = 'getApiError';
const $269a045422eaddf5$export$7845535459d8a620 = [
    $269a045422eaddf5$export$6634aa68b37142fc,
    $269a045422eaddf5$export$7ab66e58aded6116,
    $269a045422eaddf5$export$3018e0c759270938
];

});


parcelRegister("da6RM", function(module, exports) {
$parcel$export(module.exports, "useOnChangeSubscription", () => $95e26890825a5969$export$785e6020792a124f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $9TSGc = parcelRequire("9TSGc");

var $lu3pJ = parcelRequire("lu3pJ");

var $laDLc = parcelRequire("laDLc");

var $4OQs0 = parcelRequire("4OQs0");

var $3GcKx = parcelRequire("3GcKx");

var $kt5d7 = parcelRequire("kt5d7");

var $4pg3E = parcelRequire("4pg3E");
const $95e26890825a5969$export$785e6020792a124f = ({ uiModifications: uiModifications, moduleScopes: moduleScopes })=>{
    const viewType = (0, $3GcKx.useViewType)();
    const notifyAppRef = (0, $eJOHy.useRef)(null);
    const { lastProcessedChange: lastProcessedChange } = (0, $4OQs0.useLastProcessedChange)();
    const { currentFormState: currentFormState, currentScreenTabsState: currentScreenTabsState } = (0, $laDLc.useCurrentFormState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9TSGc.useAnalyticsEvents)();
    /**
	 * Single ref for all data that must be up-to-date but not trigger notification.
	 */ const dataRef = (0, $eJOHy.useRef)({
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    });
    dataRef.current = {
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    };
    (0, $eJOHy.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if (notifyApp === null || lastProcessedChange === null) return;
        const changeId = lastProcessedChange.changeId;
        notifyApp({
            changedFieldId: lastProcessedChange.fieldId,
            changeId: changeId,
            currentFormState: (0, $kt5d7.filterFormDataBasedOnScopes)(dataRef.current.currentFormState, dataRef.current.viewType, dataRef.current.moduleScopes),
            currentScreenTabsState: (0, $4pg3E.filterScreenTabsBasedOnReadScopes)(dataRef.current.moduleScopes, dataRef.current.currentScreenTabsState),
            uiModifications: dataRef.current.uiModifications
        });
        (0, $lu3pJ.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'change',
                viewType: dataRef.current.viewType
            }
        });
    }, [
        viewType,
        createAnalyticsEvent,
        lastProcessedChange
    ]);
    return (0, $eJOHy.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("laDLc", function(module, exports) {
$parcel$export(module.exports, "useCurrentFormState", () => $166a7f018f9a3c1d$export$655680d54d70050d);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $dVO4Z = parcelRequire("dVO4Z");
const $166a7f018f9a3c1d$var$stableEmpty = {};
const $166a7f018f9a3c1d$var$stableEmptyScreenTabsArrray = [];
const $166a7f018f9a3c1d$var$selectCurrentFormState = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.screenTabs, (formData, screenTabs)=>{
    if (formData !== null) return {
        currentFormState: formData,
        currentScreenTabsState: screenTabs || $166a7f018f9a3c1d$var$stableEmptyScreenTabsArrray
    };
    return {
        currentFormState: $166a7f018f9a3c1d$var$stableEmpty,
        currentScreenTabsState: $166a7f018f9a3c1d$var$stableEmptyScreenTabsArrray
    };
});
const $166a7f018f9a3c1d$export$655680d54d70050d = (0, $iJq0l.createStateHook)((0, $dVO4Z.store), {
    selector: $166a7f018f9a3c1d$var$selectCurrentFormState
});

});

parcelRegister("4OQs0", function(module, exports) {
$parcel$export(module.exports, "useLastProcessedChange", () => $c62d11fd34ef76e1$export$e5124fbd2a3221d);

var $iJq0l = parcelRequire("iJq0l");

var $dVO4Z = parcelRequire("dVO4Z");
const $c62d11fd34ef76e1$export$e5124fbd2a3221d = (0, $iJq0l.createStateHook)((0, $dVO4Z.store), {
    // We need to wrap the selected slice of state to overcome react-sweet-state useHook with selector issue.
    // We rely on the strict equality of lastUserTriggeredChange (the structure of this object
    // will not change on consecutive updates to a given field but the reference will)
    // https://github.com/atlassian/react-sweet-state/issues/167
    selector: (state)=>({
            lastProcessedChange: state.lastProcessedChange
        })
});

});

parcelRegister("kt5d7", function(module, exports) {
$parcel$export(module.exports, "filterFormDataBasedOnScopes", () => $a1b54dc1fb90b315$export$cd9f8248b807046e);
$parcel$export(module.exports, "filterFieldsChangesBasedOnScopes", () => $a1b54dc1fb90b315$export$51fbc854b278b1ff);

var $5dcci = parcelRequire("5dcci");
const $a1b54dc1fb90b315$export$4596199abc4d582e = (viewType, fieldType, moduleScopes)=>{
    const fieldRequiredScopes = (0, $5dcci.getSupportedFieldConfiguration)(viewType, fieldType)?.requiredScopes;
    if (!fieldRequiredScopes) return true;
    const includeCoarseScopes = ()=>fieldRequiredScopes.coarse.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - requiredScope is not types on CI somehow
        fieldRequiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
    const includeGranularScopes = ()=>fieldRequiredScopes.granular.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - requiredScope is not types on CI somehow
        fieldRequiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
    return includeCoarseScopes() || includeGranularScopes();
};
const $a1b54dc1fb90b315$export$cd9f8248b807046e = (formData, viewType, moduleScopes)=>{
    const formDataAsArray = Object.entries(formData);
    const filteredFormDataArray = formDataAsArray.filter(([_, value])=>{
        if (!value?.fieldType) return false;
        const { fieldType: fieldType } = value;
        return $a1b54dc1fb90b315$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFormDataArray);
};
const $a1b54dc1fb90b315$export$51fbc854b278b1ff = (fieldsChanges, formData, viewType, moduleScopes)=>{
    const fieldsChangesAsArray = Object.entries(fieldsChanges);
    const filteredFieldsChangesArray = fieldsChangesAsArray.filter(([fieldId])=>{
        const field = formData[fieldId];
        const fieldType = field?.fieldType;
        if (!fieldType) return false;
        return $a1b54dc1fb90b315$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFieldsChangesArray);
};

});

parcelRegister("4pg3E", function(module, exports) {
$parcel$export(module.exports, "filterScreenTabsBasedOnReadScopes", () => $7bb1456273cdd2ec$export$e0e73d6641eefd01);
$parcel$export(module.exports, "moduleIncludesScreenTabsWriteScopes", () => $7bb1456273cdd2ec$export$6a622a0cc96dcad7);

var $lu3pJ = parcelRequire("lu3pJ");

var $3pYnv = parcelRequire("3pYnv");
const $7bb1456273cdd2ec$var$includeCoarseScopes = (requiredScopes, moduleScopes)=>requiredScopes.coarse.length > 0 && requiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $7bb1456273cdd2ec$var$includeGranularScopes = (requiredScopes, moduleScopes)=>requiredScopes.granular.length > 0 && requiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $7bb1456273cdd2ec$export$e0e73d6641eefd01 = (moduleScopes, screenTabs)=>{
    if ($7bb1456273cdd2ec$var$includeCoarseScopes((0, $3pYnv.baseRequiredReadScopes), moduleScopes) || $7bb1456273cdd2ec$var$includeGranularScopes((0, $3pYnv.baseRequiredReadScopes), moduleScopes)) return screenTabs;
    return [];
};
const $7bb1456273cdd2ec$export$6a622a0cc96dcad7 = (viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)=>{
    if ($7bb1456273cdd2ec$var$includeCoarseScopes((0, $3pYnv.baseRequiredWriteScopes), moduleScopes) || $7bb1456273cdd2ec$var$includeGranularScopes((0, $3pYnv.baseRequiredWriteScopes), moduleScopes)) return true;
    if (Array.isArray(screenTabsChanges) && screenTabsChanges.length > 0) (0, $lu3pJ.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'missingScope',
        actionSubject: 'jiraUiModifications.screenTabs',
        attributes: {
            access: 'write',
            viewType: viewType
        }
    });
    return false;
};

});
parcelRegister("3pYnv", function(module, exports) {
$parcel$export(module.exports, "baseRequiredReadScopes", () => $1e04a45c96d34b4c$export$a6bf7d335c3c7d7f);
$parcel$export(module.exports, "baseRequiredWriteScopes", () => $1e04a45c96d34b4c$export$1f346456d218ce0a);
// for reference: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-screen-tabs/#api-group-screen-tabs
const $1e04a45c96d34b4c$export$a6bf7d335c3c7d7f = {
    granular: [
        'read:screen-tab:jira'
    ],
    coarse: [
        'read:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};
const $1e04a45c96d34b4c$export$1f346456d218ce0a = {
    granular: [
        'write:screen-tab:jira'
    ],
    coarse: [
        'write:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};

});



parcelRegister("5V6jy", function(module, exports) {
$parcel$export(module.exports, "useOnErrorSubscription", () => $95165431b83ccdaf$export$97d35fd8c60375e4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $9TSGc = parcelRequire("9TSGc");

var $lu3pJ = parcelRequire("lu3pJ");

var $bQIYV = parcelRequire("bQIYV");

var $3GcKx = parcelRequire("3GcKx");

var $dVO4Z = parcelRequire("dVO4Z");
const $95165431b83ccdaf$export$97d35fd8c60375e4 = ({ appId: appId })=>{
    const viewType = (0, $3GcKx.useViewType)();
    const notifyAppRef = (0, $eJOHy.useRef)(null);
    const { appErrors: appErrors } = (0, $bQIYV.useAppErrors)({
        appId: appId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9TSGc.useAnalyticsEvents)();
    const { resetAppErrors: resetAppErrors } = (0, $dVO4Z.useIssueAdjustmentsActions)();
    (0, $eJOHy.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(appId) || notifyApp === null || appErrors === null) return;
        notifyApp({
            errors: appErrors
        });
        (0, $lu3pJ.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'appError',
                viewType: viewType
            }
        });
        resetAppErrors({
            appId: appId
        });
    }, [
        createAnalyticsEvent,
        resetAppErrors,
        appErrors,
        appId,
        viewType
    ]);
    return (0, $eJOHy.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("bQIYV", function(module, exports) {
$parcel$export(module.exports, "useAppErrors", () => $ea99a0a357dce821$export$535312244836989b);

var $iJq0l = parcelRequire("iJq0l");

var $dVO4Z = parcelRequire("dVO4Z");
const $ea99a0a357dce821$export$535312244836989b = (0, $iJq0l.createStateHook)((0, $dVO4Z.store), {
    selector: (state, { appId: appId })=>({
            appErrors: state.appsErrors[appId] ?? null
        })
});

});


parcelRegister("i0YmB", function(module, exports) {
$parcel$export(module.exports, "useOnInit", () => $aab03fa3c862050a$export$e09230681aa762b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $9TSGc = parcelRequire("9TSGc");

var $lu3pJ = parcelRequire("lu3pJ");

var $OR9qZ = parcelRequire("OR9qZ");

var $3GcKx = parcelRequire("3GcKx");

var $dVO4Z = parcelRequire("dVO4Z");

var $5dcci = parcelRequire("5dcci");

var $kt5d7 = parcelRequire("kt5d7");

var $4pg3E = parcelRequire("4pg3E");
const $aab03fa3c862050a$var$successTabsInitialisation = (createAnalyticsEvent, viewType, screenTabsData)=>{
    if (screenTabsData.length) (0, $lu3pJ.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'success',
        actionSubject: 'jiraUiModifications.screenTabsInitialization',
        attributes: {
            initializedTabsCount: screenTabsData.length,
            viewType: viewType
        }
    });
};
const $aab03fa3c862050a$export$e09230681aa762b4 = ({ moduleScopes: moduleScopes })=>{
    const resolveOnInitPromise = (0, $eJOHy.useRef)(null);
    const viewType = (0, $3GcKx.useViewType)();
    const publicUIMDataForApp = (0, $OR9qZ.useReadyPublicDataForOnInit)({
        viewType: viewType
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9TSGc.useAnalyticsEvents)();
    const { successFieldsInitalisation: successFieldsInitalisation } = (0, $dVO4Z.useIssueAdjustmentsActions)();
    const onInitPromise = (0, $eJOHy.useMemo)(()=>{
        const promise = new Promise((resolve)=>{
            resolveOnInitPromise.current = resolve;
        });
        promise.then(()=>{
            // It cleans the resolveOnInitPromise to avoid calling the body
            // of the below useEffect after the onInit being resolved once.
            resolveOnInitPromise.current = null;
        });
        return promise;
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        const handleChange = resolveOnInitPromise.current;
        if (publicUIMDataForApp === null || handleChange === null) return;
        const payload = {
            currentFormState: (0, $kt5d7.filterFormDataBasedOnScopes)(publicUIMDataForApp.formData, viewType, moduleScopes),
            currentScreenTabsState: (0, $4pg3E.filterScreenTabsBasedOnReadScopes)(moduleScopes, publicUIMDataForApp.screenTabsData)
        };
        handleChange(payload);
        successFieldsInitalisation({
            createAnalyticsEvent: createAnalyticsEvent
        });
        (0, $lu3pJ.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'init',
                viewType: viewType
            }
        });
        $aab03fa3c862050a$var$successTabsInitialisation(createAnalyticsEvent, viewType, publicUIMDataForApp.screenTabsData);
        (0, $5dcci.getAnalytics)(viewType).markOnInitResolved();
    }, [
        successFieldsInitalisation,
        createAnalyticsEvent,
        publicUIMDataForApp,
        moduleScopes,
        viewType
    ]);
    return {
        onInitPromise: onInitPromise
    };
};

});
parcelRegister("OR9qZ", function(module, exports) {
$parcel$export(module.exports, "useReadyPublicDataForOnInit", () => $4665c73035b41c02$export$484a467ba25fea19);

var $iJq0l = parcelRequire("iJq0l");

var $dVO4Z = parcelRequire("dVO4Z");

var $cf0vb = parcelRequire("cf0vb");
const $4665c73035b41c02$export$484a467ba25fea19 = (0, $iJq0l.createStateHook)((0, $dVO4Z.store), {
    selector: (0, $cf0vb.selectReadyPublicDataForOnInit)
});

});


parcelRegister("gHcMh", function(module, exports) {
$parcel$export(module.exports, "useRegisterFields", () => $4b33d1a5baab7a01$export$fe9a0f40214d6955);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $3GcKx = parcelRequire("3GcKx");

var $dVO4Z = parcelRequire("dVO4Z");

var $5dcci = parcelRequire("5dcci");
const $4b33d1a5baab7a01$export$fe9a0f40214d6955 = ({ appId: appId })=>{
    const { setError: setError, registerFields: registerFields } = (0, $dVO4Z.useIssueAdjustmentsActions)();
    const viewType = (0, $3GcKx.useViewType)();
    return (0, $eJOHy.useCallback)(async ({ fields: fields, changeId: changeId })=>{
        try {
            // We want to register only fields that are strings.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const validFieldIds = fields.filter((fieldId)=>typeof fieldId === 'string');
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            if (typeof changeId === 'string') registerFields({
                changeId: changeId,
                fieldsToBeRegistered: validFieldIds,
                appId: appId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_REGISTER_FIELDS_ERROR_CODE'
            });
            throw err;
        } finally{
            (0, $5dcci.getAnalytics)(viewType).markFieldsRegistered();
        }
    }, [
        appId,
        registerFields,
        setError,
        viewType
    ]);
};

});

parcelRegister("j9qqW", function(module, exports) {
$parcel$export(module.exports, "useSubmit", () => $abc83bd96ff46508$export$47c85c6e3a081d3);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $j4oe4 = parcelRequire("j4oe4");

var $9TSGc = parcelRequire("9TSGc");

var $kcZQW = parcelRequire("kcZQW");
var $lu3pJ = parcelRequire("lu3pJ");
var $e06dx = parcelRequire("e06dx");

var $iKdPZ = parcelRequire("iKdPZ");

var $1DCXA = parcelRequire("1DCXA");

var $3GcKx = parcelRequire("3GcKx");

var $dVO4Z = parcelRequire("dVO4Z");

var $f5yMv = parcelRequire("f5yMv");

var $8bF5A = parcelRequire("8bF5A");

var $5dcci = parcelRequire("5dcci");

var $4pg3E = parcelRequire("4pg3E");

var $6rATv = parcelRequire("6rATv");

var $66OVj = parcelRequire("66OVj");
const $abc83bd96ff46508$export$47c85c6e3a081d3 = ({ moduleScopes: moduleScopes, appId: appId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9TSGc.useAnalyticsEvents)();
    const { updateFields: updateFields, setError: setError, unregisterFields: unregisterFields, setAppErrors: setAppErrors, updateScreenTabs: updateScreenTabs, detectAppliedChangesConflicts: detectAppliedChangesConflicts } = (0, $dVO4Z.useIssueAdjustmentsActions)();
    const viewType = (0, $3GcKx.useViewType)();
    const getAsyncLookupData = (0, $1DCXA.useLookupFieldData)();
    const getFilteredFieldChangesBasedOnScope = (0, $66OVj.useFilterFieldChangesBasedOnScope)(moduleScopes);
    const tenantContext = (0, $8bF5A.useTenantContext)();
    const executionContext = (0, $iKdPZ.useExecutionContext)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const getValidatedFieldsChanges = (0, $6rATv.useFieldsChangesValidation)();
    const intl = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)(async ({ fieldsChanges: fieldsChangesUnnormalized, screenTabsChanges: screenTabsChanges, changeId: changeId })=>{
        try {
            const fieldsChanges = getFilteredFieldChangesBasedOnScope(fieldsChangesUnnormalized);
            const validatedFieldsChanges = await getValidatedFieldsChanges(fieldsChanges);
            const lookupDataFromApi = await getAsyncLookupData(validatedFieldsChanges);
            await updateFields({
                changeId: changeId,
                fieldsChanges: fieldsChanges,
                lookupDataFromApi: lookupDataFromApi,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                appId: appId,
                intl: intl,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (screenTabsChanges && (0, $4pg3E.moduleIncludesScreenTabsWriteScopes)(viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)) updateScreenTabs({
                screenTabsChanges: screenTabsChanges,
                appId: appId,
                changeId: changeId
            });
            detectAppliedChangesConflicts({
                appId: appId,
                changeId: changeId
            });
            (0, $5dcci.getAnalytics)(viewType).stopTTI({
                completionStatus: 'success',
                viewType: viewType
            });
            (0, $e06dx.fireTrackEvent)(createAnalyticsEvent, {
                action: 'success',
                actionSubject: `${viewType}jiraUiModificationsUseSubmit`
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_SUBMIT_ERROR_CODE'
            });
            (0, $5dcci.getAnalytics)(viewType).stopTTI({
                completionStatus: 'error',
                viewType: viewType
            });
            if (err instanceof (0, $f5yMv.UiModificationsValidationError)) {
                (0, $lu3pJ.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'failed',
                    actionSubject: 'jiraUiModifications.changesValidation',
                    attributes: {
                        type: err.validationErrorType,
                        ...err.attributes,
                        viewType: viewType
                    }
                });
                // Setting app errors to pass them to the onErrorCallback
                setAppErrors({
                    errors: err.attributes.errors,
                    appId: appId
                });
                return;
            }
            (0, $kcZQW.fireErrorAnalytics)({
                error: err,
                id: 'useSubmit',
                viewType: viewType,
                attributes: {
                    errorCause: err?.cause
                },
                event: createAnalyticsEvent({})
            });
        } finally{
            unregisterFields({
                changeId: changeId,
                appId: appId
            });
        }
    }, [
        getFilteredFieldChangesBasedOnScope,
        getValidatedFieldsChanges,
        getAsyncLookupData,
        updateFields,
        tenantContext,
        executionContext,
        environment,
        appId,
        intl,
        viewType,
        createAnalyticsEvent,
        moduleScopes,
        updateScreenTabs,
        detectAppliedChangesConflicts,
        setError,
        setAppErrors,
        unregisterFields
    ]);
};

});
parcelRegister("e06dx", function(module, exports) {
$parcel$export(module.exports, "fireTrackEvent", () => $b7b359673978e783$export$574d2f19a52d67ca);

var $9EgTk = parcelRequire("9EgTk");


const $b7b359673978e783$export$574d2f19a52d67ca = (createAnalyticsEvent, eventPayload)=>{
    (0, $9EgTk.default)((0, $064fad4619986aeb$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $c8420ac01384d575$export$947dac6c72b26f81)
    })(createAnalyticsEvent);
};

});
const $c8420ac01384d575$export$f636b5b56f1d624a = 'Screen';
const $c8420ac01384d575$export$9d2de6eebf7462b5 = 'Drawer';
const $c8420ac01384d575$export$1171103ea9083ffa = 'Modal';
const $c8420ac01384d575$export$cae2783c9279926 = 'InlineDialog';
const $c8420ac01384d575$export$d1123261ca8831d2 = 'Dropdown';
const $c8420ac01384d575$export$a1562d08625f5d7e = 'UI';
const $c8420ac01384d575$export$947dac6c72b26f81 = 'TRACK';
const $c8420ac01384d575$export$f1d537d508d2945a = 'SCREEN';
const $c8420ac01384d575$export$12346a674644c156 = 'OPERATIONAL';
const $c8420ac01384d575$export$2ceccf177fae277c = 'analyticsBridge';

const $064fad4619986aeb$export$8280e5c6104c5b40 = 'ui-modifications';


parcelRegister("1DCXA", function(module, exports) {
$parcel$export(module.exports, "useLookupFieldData", () => $e145ee82e08d037b$export$d43e9e394c54e784);

var $eJOHy = parcelRequire("eJOHy");

var $jvwCK = parcelRequire("jvwCK");

var $gRw8I = parcelRequire("gRw8I");

var $j4oe4 = parcelRequire("j4oe4");

var $9TSGc = parcelRequire("9TSGc");


var $iszqF = parcelRequire("iszqF");

var $gBBPv = parcelRequire("gBBPv");

var $jhgbA = parcelRequire("jhgbA");

var $3GcKx = parcelRequire("3GcKx");

var $5dcci = parcelRequire("5dcci");
const $e145ee82e08d037b$export$d43e9e394c54e784 = ()=>{
    (0, $gRw8I.di)((0, $j4oe4.useRelayEnvironment), (0, $jhgbA.useFormMetadata), (0, $gBBPv.fetchUsers), (0, $3GcKx.useViewType));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9TSGc.useAnalyticsEvents)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const formMetadata = (0, $jhgbA.useFormMetadata)();
    const formMetadataRef = (0, $eJOHy.useRef)(formMetadata);
    const viewType = (0, $3GcKx.useViewType)();
    /**
	 * We want to have an up-to-date data when this hook's
	 * returned function is being called in useSubmit callback function
	 * thats why we keep it in a ref object
	 */ formMetadataRef.current = formMetadata;
    return (0, $eJOHy.useCallback)(async (fieldsChanges)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const lookupData = {};
        const asyncFieldsValues = Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldData])=>{
            if (!formMetadataRef.current[fieldId]) return acc;
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValue = fieldData.value;
            const supportedFieldsConfiguration = (0, $5dcci.getSupportedFieldConfiguration)(viewType, fieldType);
            const lookupSource = supportedFieldsConfiguration?.lookupSource;
            const isUserLookupField = lookupSource === (0, $9d6442f4dd34ae3e$export$3a106242c8f57ac2);
            if (isUserLookupField && fieldValue && (0, $iszqF.isNotAutomaticId)(fieldValue)) {
                const currentAccountIds = acc.accountIds ? [
                    ...acc.accountIds
                ] : [];
                const newAccountIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.accountIds = [
                    ...currentAccountIds,
                    ...newAccountIds
                ];
            }
            /** Add extra checks to add other lookup type e.g. issues lookup */ return acc;
        }, {});
        let users = [];
        if (asyncFieldsValues.accountIds) {
            const uniqueAccountIds = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(asyncFieldsValues.accountIds);
            users = await (0, $gBBPv.fetchUsers)(environment, uniqueAccountIds, createAnalyticsEvent);
        }
        lookupData[0, $9d6442f4dd34ae3e$export$3a106242c8f57ac2] = users;
        return lookupData;
    }, [
        createAnalyticsEvent,
        viewType,
        environment
    ]);
};

});
const $9d6442f4dd34ae3e$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $9d6442f4dd34ae3e$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $9d6442f4dd34ae3e$export$f5d5f6bb902f1027 = '-1';
const $9d6442f4dd34ae3e$export$106087dcfd4fb129 = 100;

parcelRegister("iszqF", function(module, exports) {
$parcel$export(module.exports, "isNotAutomaticId", () => $7cc12f624d518892$export$ab4c3a3c49d7add);

const $7cc12f624d518892$export$ab4c3a3c49d7add = (value)=>value !== (0, $9d6442f4dd34ae3e$export$f5d5f6bb902f1027);

});

parcelRegister("gBBPv", function(module, exports) {
$parcel$export(module.exports, "fetchUsers", () => $8bc20043ad2fb5ea$export$2bb8333a9210be15);

var $eqhua = parcelRequire("eqhua");

var $j4oe4 = parcelRequire("j4oe4");

var $lu3pJ = parcelRequire("lu3pJ");

var $gFLzB = parcelRequire("gFLzB");
const $8bc20043ad2fb5ea$export$2bb8333a9210be15 = async (environment, accountIds, createAnalyticsEvent)=>{
    try {
        const apiStartTime = performance.now();
        const response = await (0, $j4oe4.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $eqhua.default), {
            accountIds: accountIds
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!response?.users) throw new (0, $gFLzB.ErrorWithStatusCode)('[fetch-users service] [fetchUsersQuery]: Property users does not exist.', {
            cause: 'FETCH_USERS_MISSING_USERS_PROPERTY'
        }, 'FETCH_USERS_MISSING_USERS_PROPERTY');
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $lu3pJ.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchUsers',
            attributes: {
                usersAPILatency: apiLatencyMs
            }
        });
        return [
            ...response.users
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_USERS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("eqhua", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8bc30de16a3e3d2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6109c01c0559b2d0812b75c892a215b7>>
 * @relayHash 8d49f086e404cd774990851cc2a7daa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def
const $d8bc30de16a3e3d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def",
            "metadata": {},
            "name": "fetchUsersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d8bc30de16a3e3d2$var$node.hash = "55c7a5d564d3036b3714730d97d87482";
var $d8bc30de16a3e3d2$export$2e2bcd8739ae039 = $d8bc30de16a3e3d2$var$node;

});

parcelRegister("gFLzB", function(module, exports) {
$parcel$export(module.exports, "ErrorWithStatusCode", () => $e43858356ecbe36e$export$13144d723cf04c);
class $e43858356ecbe36e$export$13144d723cf04c extends Error {
    constructor(message, options, statusCode){
        super(message, options);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("jhgbA", function(module, exports) {
$parcel$export(module.exports, "useFormMetadata", () => $ebbb37c2c4623082$export$863414fa128cb7ef);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $dVO4Z = parcelRequire("dVO4Z");
const $ebbb37c2c4623082$var$selectFormMetadata = (0, $4MchI.createSelector)((state)=>state.internalFormMetadata, (metadata)=>metadata);
const $ebbb37c2c4623082$export$863414fa128cb7ef = (0, $iJq0l.createStateHook)((0, $dVO4Z.store), {
    selector: $ebbb37c2c4623082$var$selectFormMetadata
});

});


parcelRegister("6rATv", function(module, exports) {
$parcel$export(module.exports, "useFieldsChangesValidation", () => $cb147b762692fc27$export$e3505fcc03e08574);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $9TSGc = parcelRequire("9TSGc");

var $laDLc = parcelRequire("laDLc");

var $jhgbA = parcelRequire("jhgbA");

var $3GcKx = parcelRequire("3GcKx");

var $3Mo9I = parcelRequire("3Mo9I");

var $hi4Qb = parcelRequire("hi4Qb");
const $cb147b762692fc27$var$filterInvalidResults = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $cb147b762692fc27$var$mapValidResultsToFieldChangesMap = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true) {
            const { data: { fieldId: fieldId, fieldData: fieldData } } = result;
            acc[fieldId] = fieldData;
        }
        return acc;
    }, {});
const $cb147b762692fc27$export$e3505fcc03e08574 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9TSGc.useAnalyticsEvents)();
    const formMetadata = (0, $jhgbA.useFormMetadata)();
    const formMetadataRef = (0, $eJOHy.useRef)(formMetadata);
    const viewType = (0, $3GcKx.useViewType)();
    const { currentFormState: currentFormState } = (0, $laDLc.useCurrentFormState)();
    const currentFormStateRef = (0, $eJOHy.useRef)(currentFormState);
    /**
	 * We want to have an up-to-date data when this hook's
	 * returned function is being called in useSubmit callback function
	 * thats why we keep it in a ref object
	 */ formMetadataRef.current = formMetadata;
    currentFormStateRef.current = currentFormState;
    return (0, $eJOHy.useCallback)(async (fieldsChanges)=>{
        const fieldsChangesValidationResult = await Promise.all(Object.entries(fieldsChanges).filter(([fieldId])=>{
            return formMetadataRef.current[fieldId] !== undefined;
        }).map(async ([fieldId, fieldData])=>{
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValidationResult = await (0, $hi4Qb.validateFieldChanges)({
                fieldType: fieldType,
                fieldId: fieldId,
                viewType: viewType,
                createAnalyticsEvent: createAnalyticsEvent,
                fieldMetadata: formMetadataRef.current[fieldId],
                currentField: currentFormStateRef.current[fieldId],
                fieldFromIframe: fieldData
            });
            if (fieldValidationResult.isValid === false) return fieldValidationResult;
            return {
                ...fieldValidationResult,
                data: {
                    fieldId: fieldId,
                    fieldData: fieldData
                }
            };
        }));
        const failedValidationResults = $cb147b762692fc27$var$filterInvalidResults(fieldsChangesValidationResult);
        if (failedValidationResults.length) throw new (0, $3Mo9I.UiModificationsFieldsValidationError)('Validation failed', {
            errors: failedValidationResults.flatMap((result)=>result.errors)
        });
        return $cb147b762692fc27$var$mapValidResultsToFieldChangesMap(fieldsChangesValidationResult);
    }, [
        createAnalyticsEvent,
        viewType
    ]);
};

});
parcelRegister("hi4Qb", function(module, exports) {
$parcel$export(module.exports, "validateFieldChanges", () => $56288b7f3baf0c46$export$a2b7ddd7c3d0703a);

var $5dcci = parcelRequire("5dcci");

var $1rOCU = parcelRequire("1rOCU");

var $dP89I = parcelRequire("dP89I");
const $56288b7f3baf0c46$export$a2b7ddd7c3d0703a = async ({ fieldType: fieldType, fieldId: fieldId, currentField: currentField, fieldFromIframe: fieldFromIframe, fieldMetadata: fieldMetadata, viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
    const fieldConfiguration = (0, $5dcci.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldValidators) return 0, $1rOCU.VALID_RESULT;
    const validatorsArray = Object.entries(fieldValidators);
    const fieldValidationResults = await Promise.all(validatorsArray.map(async ([propertyName, validate])=>{
        if ((0, $dP89I.isFieldPropertyName)(fieldFromIframe, propertyName)) {
            const propertyValue = fieldFromIframe[propertyName];
            const validationResult = await validate(propertyValue, fieldMetadata, createAnalyticsEvent, {
                currentField: currentField,
                viewType: viewType
            });
            return (0, $dP89I.prepareValidationResult)({
                validationResult: validationResult,
                fieldId: fieldId,
                fieldType: fieldType,
                propertyName: propertyName
            });
        }
        return 0, $1rOCU.VALID_RESULT;
    }));
    const invalidValidationResult = (0, $dP89I.filterInvalidResults)(fieldValidationResults);
    if (invalidValidationResult.length > 0) return {
        isValid: false,
        errors: invalidValidationResult.map((result)=>result.error)
    };
    return 0, $1rOCU.VALID_RESULT;
};

});
parcelRegister("1rOCU", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $863b6a422587ac9f$export$ee79e3ab53b8db79);
const $863b6a422587ac9f$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("dP89I", function(module, exports) {
$parcel$export(module.exports, "prepareValidationResult", () => $3c41568d9df5ab63$export$971a38960a5f1064);
$parcel$export(module.exports, "filterInvalidResults", () => $3c41568d9df5ab63$export$ddd005554aecd409);
$parcel$export(module.exports, "isFieldPropertyName", () => $3c41568d9df5ab63$export$fd744b06c9068a9e);


var $aXHLO = parcelRequire("aXHLO");

var $1rOCU = parcelRequire("1rOCU");
const $3c41568d9df5ab63$var$prepareValidationResultByBooleanValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    if (validationResult === false) return {
        isValid: false,
        error: {
            type: (0, $d00e40c17cda1902$export$d1996cb46a690190),
            method: (0, $aXHLO.mapFieldPropertyToApiMethod)(propertyName),
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $1rOCU.VALID_RESULT;
};
const $3c41568d9df5ab63$var$prepareValidationResultByExtendedValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType })=>{
    if (validationResult.isValid === false) return {
        isValid: false,
        error: {
            type: (0, $d00e40c17cda1902$export$d1996cb46a690190),
            method: validationResult.error.method,
            message: validationResult.error.message,
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $1rOCU.VALID_RESULT;
};
const $3c41568d9df5ab63$export$971a38960a5f1064 = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    // We will remove the boolean check and old method after changing all validators to return objects
    if (typeof validationResult === 'boolean') return $3c41568d9df5ab63$var$prepareValidationResultByBooleanValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType,
        propertyName: propertyName
    });
    return $3c41568d9df5ab63$var$prepareValidationResultByExtendedValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType
    });
};
const $3c41568d9df5ab63$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $3c41568d9df5ab63$export$fd744b06c9068a9e = (fieldFromIframe, propertyName)=>Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName);

});
const $d00e40c17cda1902$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $d00e40c17cda1902$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $d00e40c17cda1902$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $d00e40c17cda1902$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $d00e40c17cda1902$export$e4ac32edd5da2ee7 = 'FIELD';
const $d00e40c17cda1902$export$877da1000325f8b5 = 'SCREENTABS';




parcelRegister("66OVj", function(module, exports) {
$parcel$export(module.exports, "useFilterFieldChangesBasedOnScope", () => $ede2381548322424$export$2ee317ef8ccc699f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $laDLc = parcelRequire("laDLc");

var $3GcKx = parcelRequire("3GcKx");

var $kt5d7 = parcelRequire("kt5d7");
const $ede2381548322424$export$2ee317ef8ccc699f = (moduleScopes)=>{
    const { currentFormState: currentFormState } = (0, $laDLc.useCurrentFormState)();
    const currentFormStateRef = (0, $eJOHy.useRef)(currentFormState);
    const viewType = (0, $3GcKx.useViewType)();
    /**
	 * We want to have an up-to-date data when this hook's
	 * returned function is being called in useSubmit callback function
	 * thats why we keep it in a ref object
	 */ currentFormStateRef.current = currentFormState;
    return (0, $eJOHy.useCallback)((fieldChanges)=>(0, $kt5d7.filterFieldsChangesBasedOnScopes)(fieldChanges, currentFormStateRef.current, viewType, moduleScopes), [
        moduleScopes,
        viewType
    ]);
};

});



parcelRegister("ltaAX", function(module, exports) {
$parcel$export(module.exports, "useIframeTimeout", () => $62502b09136a237a$export$39fbc0513eb03420);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $9TSGc = parcelRequire("9TSGc");

var $lu3pJ = parcelRequire("lu3pJ");

var $3GcKx = parcelRequire("3GcKx");
const $62502b09136a237a$export$45f7ef64ce535ffd = 12000;
const $62502b09136a237a$export$39fbc0513eb03420 = ({ forgeExtension: forgeExtension })=>{
    const timeoutRef = (0, $eJOHy.useRef)(undefined);
    const callbackRef = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9TSGc.useAnalyticsEvents)();
    const viewType = (0, $3GcKx.useViewType)();
    const onTimeout = (0, $eJOHy.useCallback)(()=>{
        const { id: id } = forgeExtension;
        (0, $lu3pJ.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'failed',
            actionSubject: 'jiraUiModifications.iframeTimeout',
            attributes: {
                timeoutAfter: `${$62502b09136a237a$export$45f7ef64ce535ffd / 1000}s`,
                extensionId: id,
                viewType: viewType
            }
        });
    }, [
        forgeExtension,
        viewType,
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        callbackRef.current = onTimeout;
    }, [
        onTimeout
    ]);
    const setLoadingComplete = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // For details on why we need to evaluate the callback in this way, see
        // https://www.joshwcomeau.com/snippets/react-hooks/use-timeout/#explanation
        // tl;dr: it allows the latest version of `onTimeout` to be called, without
        // needing to cancel and start a new timer each time dependencies change
        const callback = ()=>callbackRef.current();
        timeoutRef.current = setTimeout(callback, $62502b09136a237a$export$45f7ef64ce535ffd);
        return ()=>clearTimeout(timeoutRef.current);
    }, []);
    return {
        setLoadingComplete: setLoadingComplete
    };
};

});

parcelRegister("5svRh", function(module, exports) {
$parcel$export(module.exports, "useScopeChecks", () => $710c889976271fd0$export$5b312a37a22a70a8);

var $447VJ = parcelRequire("447VJ");
const $710c889976271fd0$export$5b312a37a22a70a8 = (appInstallationScopes)=>{
    if (appInstallationScopes) {
        const appHasAllRequiredCoarseScopes = (0, $447VJ.REQUIRED_COARSE_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
        if (appHasAllRequiredCoarseScopes) return true;
        return (0, $447VJ.REQUIRED_GRANULAR_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
    }
    return false;
};

});
parcelRegister("447VJ", function(module, exports) {
$parcel$export(module.exports, "REQUIRED_GRANULAR_SCOPES", () => $f831d77110782804$export$81920d3428c141d1);
$parcel$export(module.exports, "REQUIRED_COARSE_SCOPES", () => $f831d77110782804$export$bdf22b2c717ce672);
// https://hello.atlassian.net/wiki/spaces/unbx/pages/1732638810/RFC+Set+of+scopes+to+be+required+in+UI+modifications+extension+point+in+GIC+location
const $f831d77110782804$export$81920d3428c141d1 = [
    'read:project:jira',
    'read:issue-type:jira',
    'read:user-configuration:jira',
    'read:user:jira',
    'read:issue:jira',
    'read:priority:jira',
    'read:label:jira',
    'read:license:jira',
    'read:field:jira',
    'read:field-configuration:jira',
    'write:field-configuration:jira',
    'write:field.default-value:jira',
    'write:field:jira'
];
const $f831d77110782804$export$bdf22b2c717ce672 = [
    'manage:jira-configuration',
    'read:jira-user',
    'read:jira-work',
    'write:jira-work'
];

});


parcelRegister("c04JC", function(module, exports) {
$parcel$export(module.exports, "useThreeLOPromptProps", () => $e44c272dd6b8e45c$export$cb62ba9a2eb7a0b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $9TSGc = parcelRequire("9TSGc");

var $5IjLF = parcelRequire("5IjLF");

var $lu3pJ = parcelRequire("lu3pJ");

var $3faLh = parcelRequire("3faLh");

var $deXzx = parcelRequire("deXzx");


var $3GcKx = parcelRequire("3GcKx");

var $5dcci = parcelRequire("5dcci");
const $e44c272dd6b8e45c$export$cb62ba9a2eb7a0b4 = ({ forgeExtension: forgeExtension })=>{
    const [hasBeenTracked, setHasBeenTracked] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9TSGc.useAnalyticsEvents)();
    const { setUIModificationsConsentStatus: setUIModificationsConsentStatus } = (0, $3faLh.useAdjustmentsContextActions)();
    const { appId: appId } = (0, $5IjLF.parseExtensionId)(forgeExtension.id);
    const viewType = (0, $3GcKx.useViewType)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const currentUIModificationsConsentStatus = (0, $deXzx.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    const onConsentSuccess = (0, $eJOHy.useCallback)(()=>{
        setUIModificationsConsentStatus({
            appId: appId,
            status: (0, $d289da392ecd1c15$export$45ca911896c5084f)
        });
        (0, $lu3pJ.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'cleared',
            actionSubject: 'jiraUiModificationsObligatoryConsent'
        });
    }, [
        appId,
        createAnalyticsEvent,
        setUIModificationsConsentStatus
    ]);
    const onConsentInitialization = (0, $eJOHy.useCallback)(()=>{
        if (currentUIModificationsConsentStatus === (0, $d289da392ecd1c15$export$39d15f3568f5a72c)) {
            setUIModificationsConsentStatus({
                appId: appId,
                status: (0, $d289da392ecd1c15$export$d67d63332ce3ce38)
            });
            if (!hasBeenTracked) {
                (0, $lu3pJ.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'triggered',
                    actionSubject: 'jiraUiModifications.obligatoryConsent',
                    attributes: {
                        viewType: viewType
                    }
                });
                setHasBeenTracked(true);
            }
        }
    }, [
        appId,
        currentUIModificationsConsentStatus,
        setUIModificationsConsentStatus,
        hasBeenTracked,
        viewType,
        createAnalyticsEvent
    ]);
    const consentMessage = (0, $eJOHy.useMemo)(()=>{
        return formatMessage((0, $5dcci.getConsentMessage)(viewType), {
            appTitle: forgeExtension.properties.title
        });
    }, [
        formatMessage,
        forgeExtension.properties.title,
        viewType
    ]);
    const threeLOPromptComponentPropsMethods = (0, $eJOHy.useMemo)(()=>({
            onConsentSuccess: onConsentSuccess,
            onConsentInitialization: onConsentInitialization,
            consentMessage: consentMessage
        }), [
        onConsentSuccess,
        onConsentInitialization,
        consentMessage
    ]);
    return threeLOPromptComponentPropsMethods;
};

});

parcelRegister("58a6U", function(module, exports) {
$parcel$export(module.exports, "buildExtensionData", () => $a0a7594b19b3574a$export$141a9933f8885d99);

const $a0a7594b19b3574a$export$141a9933f8885d99 = (executionContext)=>{
    return {
        type: (0, $66e1e5b286ca8af9$export$811b7f067a43b422),
        ...executionContext
    };
};

});



parcelRegister("i3itQ", function(module, exports) {
$parcel$export(module.exports, "useAppsToRender", () => $218c58c5025e6a4b$export$bef357953bcc2428);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $9TSGc = parcelRequire("9TSGc");

var $lu3pJ = parcelRequire("lu3pJ");

var $3faLh = parcelRequire("3faLh");

var $3GcKx = parcelRequire("3GcKx");

var $dVO4Z = parcelRequire("dVO4Z");


var $3UPi2 = parcelRequire("3UPi2");
const $218c58c5025e6a4b$export$bef357953bcc2428 = (payload)=>{
    const { data: data, executionContextKey: executionContextKey } = payload;
    const { startFieldsInitialisationTimeout: startFieldsInitialisationTimeout } = (0, $dVO4Z.useIssueAdjustmentsActions)();
    const { setAdjustmentsAreEnabled: setAdjustmentsAreEnabled, setHasFinishedLoading: setHasFinishedLoading } = (0, $3faLh.useAdjustmentsContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9TSGc.useAnalyticsEvents)();
    const viewType = (0, $3GcKx.useViewType)();
    const configuredApps = (0, $eJOHy.useMemo)(()=>(0, $3UPi2.getConfiguredApps)(data.jira?.forge?.uiModificationsExtensions, data.jira?.uiModifications), [
        data.jira?.forge?.uiModificationsExtensions,
        data.jira?.uiModifications
    ]);
    const appsToRender = (0, $eJOHy.useMemo)(()=>{
        return configuredApps.slice(0, (0, $9fd803a254ee3f75$export$575c2f3c7fe81caa));
    }, [
        configuredApps
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (data.jira?.uiModifications !== undefined) setHasFinishedLoading(true);
    }, [
        setHasFinishedLoading,
        data.jira?.uiModifications
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (appsToRender.length > 0) {
            setAdjustmentsAreEnabled(true);
            startFieldsInitialisationTimeout({
                createAnalyticsEvent: createAnalyticsEvent
            });
        }
    }, [
        appsToRender,
        setAdjustmentsAreEnabled,
        startFieldsInitialisationTimeout,
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const configuredAppsCount = configuredApps.length;
        if (configuredAppsCount >= 1) (0, $lu3pJ.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.configuredAppsPerContext',
            attributes: {
                forgeModulesCount: data.jira?.forge?.uiModificationsExtensions.length,
                uimConfiguredAppCount: data.jira?.uiModifications.length,
                configuredAndInstalledApps: configuredAppsCount,
                areMultipleAppsConfiguredAndInstalled: configuredAppsCount > 1,
                viewType: viewType
            }
        });
    }, [
        // `executionContextKey` is required to track events when execution context changed
        executionContextKey,
        viewType,
        createAnalyticsEvent,
        configuredApps.length,
        data.jira?.forge?.uiModificationsExtensions.length,
        data.jira?.uiModifications.length
    ]);
    return appsToRender;
};

});
const $9fd803a254ee3f75$export$575c2f3c7fe81caa = 5;

parcelRegister("3UPi2", function(module, exports) {
$parcel$export(module.exports, "getConfiguredApps", () => $41c41b1a774b1d8a$export$6ead423ef319ea49);

var $8Ry0i = parcelRequire("8Ry0i");
const $41c41b1a774b1d8a$var$STABLE_EMPTY_ARRAY = [];
const $41c41b1a774b1d8a$export$6ead423ef319ea49 = (forgeExtensions, uiModificationsConfigs)=>{
    if (!forgeExtensions || !uiModificationsConfigs) return $41c41b1a774b1d8a$var$STABLE_EMPTY_ARRAY;
    // Put modules in the HashMap for a fast search & get by appEnvId
    const modulesHashMap = (0, $8Ry0i.normalizeExtensions)(forgeExtensions);
    return uiModificationsConfigs.filter((configuration)=>!!modulesHashMap[configuration.appEnvId]).map((configuration)=>({
            forgeExtension: modulesHashMap[configuration.appEnvId],
            uiModificationsConfig: configuration.uiModifications.map(({ id: id, data: data })=>({
                    id: id,
                    data: data
                }))
        }));
};

});
parcelRegister("8Ry0i", function(module, exports) {
$parcel$export(module.exports, "normalizeExtensions", () => $55f6c8d86a168c99$export$7e2e604b6166a087);

var $5IjLF = parcelRequire("5IjLF");
const $55f6c8d86a168c99$export$7e2e604b6166a087 = (forgeExtensions)=>forgeExtensions.reduce((accumulator, current)=>{
        const { appId: appId, environmentId: envId } = (0, $5IjLF.parseExtensionId)(current.id);
        const combinedAppEnvId = `${appId}/${envId}`;
        // by this condition we make sure the first IA module is rendered (appEnvId key is not overwritten)
        // and integration code is deterministic (if you add a new IA module,
        // the 1st one will be rendered, not the last one)
        if (!accumulator[combinedAppEnvId]) accumulator[combinedAppEnvId] = current;
        return accumulator;
    }, {});

});



parcelRegister("kpf82", function(module, exports) {
$parcel$export(module.exports, "useContextCleanup", () => $c185a04dbbaf8d7e$export$c704babd3a8c2350);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $eJOHy = parcelRequire("eJOHy");

var $3faLh = parcelRequire("3faLh");

var $3GcKx = parcelRequire("3GcKx");

var $dVO4Z = parcelRequire("dVO4Z");

var $5dcci = parcelRequire("5dcci");
const $c185a04dbbaf8d7e$export$c704babd3a8c2350 = (payload)=>{
    const { executionContextKey: executionContextKey, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = payload;
    const { resetAllFields: resetAllFields, triggerFieldInitialization: triggerFieldInitialization, setNumberOfSupportedFields: setNumberOfSupportedFields } = (0, $dVO4Z.useIssueAdjustmentsActions)();
    const { resetAdjustmentContext: resetAdjustmentContext } = (0, $3faLh.useAdjustmentsContextActions)();
    const viewType = (0, $3GcKx.useViewType)();
    (0, $eJOHy.useEffect)(()=>{
        if (numberOfSupportedFields !== undefined) setNumberOfSupportedFields(numberOfSupportedFields);
        return ()=>setNumberOfSupportedFields(0);
    }, [
        numberOfSupportedFields,
        setNumberOfSupportedFields
    ]);
    (0, $eJOHy.useEffect)(()=>{
        triggerFieldInitialization();
        return resetAllFields;
    // Whenever the executionContextKey is changed, or the resetFormFieldsCounter
    // is incremented ("create another issue" GIC) we want to reset any data in our store.
    // For "create another issue" `resetFormFieldsCounter` we trigger re-initialization of field data.
    }, [
        executionContextKey,
        resetFormFieldsCounter,
        resetAllFields,
        triggerFieldInitialization
    ]);
    (0, $eJOHy.useEffect)(()=>()=>{
            resetAdjustmentContext();
            (0, $5dcci.getAnalytics)(viewType).cancelTTI();
        }, // When executionContextKey is changed we reset the AdjustmentsContext because
    // other executionContextKey may not be configured to run UI modifications
    [
        executionContextKey,
        resetAdjustmentContext,
        viewType
    ]);
};

});

parcelRegister("h6Jc5", function(module, exports) {
$parcel$export(module.exports, "useEnrichedExecutionContext", () => $3cdc774bbfa4ce73$export$649da33b72723913);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $3GcKx = parcelRequire("3GcKx");
const $3cdc774bbfa4ce73$export$649da33b72723913 = ({ executionContext: executionContext })=>{
    (0, $gRw8I.di)((0, $3GcKx.useViewType));
    const viewType = (0, $3GcKx.useViewType)();
    const enrichedExecutionContext = (0, $eJOHy.useMemo)(()=>{
        return executionContext && {
            ...executionContext,
            viewType: viewType
        };
    }, [
        executionContext,
        viewType
    ]);
    return enrichedExecutionContext;
};

});





//# sourceMappingURL=async-ui-modifications-root-entrypoint.9cc6b18c.js.map
